import { Box, SxProps } from '@mui/material';
import { Theme } from '@mui/system';

function BoldText({ text, sx }: { text: string; sx?: SxProps<Theme> }) {
  return (
    <Box sx={{ minWidth: 100, typography: `${text}`, color: '#262728', fontWeight: 500, fontSize: 14, m: 1, ...sx }}>
      {text}
    </Box>
  );
}

export default BoldText;
